const paymentCategoryLogoDictionary = {
  Card: {
    logo: "/assets/Icons/Payment Instruments/card.svg",
    logoColored: "/assets/paymentIcons/CardsLogo.svg",
  },
  Upi: {
    logo: "/assets/Icons/Payment Instruments/UPI.svg",
    logoColored: "/assets/paymentIcons/UPILogo.svg",
  },
  NetBanking: {
    logo: "/assets/Icons/Payment Instruments/netBanking.svg",
    logoColored: "/assets/paymentIcons/NetBankingLogo.svg",
  },
  Wallet: {
    logo: "/assets/Icons/Payment Instruments/wallet.svg",
    logoColored: "/assets/paymentIcons/WalletsLogo.svg",
  },
  BuyNowPayLater: {
    logo: "/assets/Icons/Payment Instruments/BNPL.svg",
    logoColored: "/assets/paymentIcons/BNPL.svg",
  },
  Crypto: {
    logo: "/assets/Icons/Payment Instruments/crypto.svg",
    logoColored: "/assets/paymentIcons/crypto.svg",
  },
  Paynow: {
    logo: "/assets/Icons/Payment Instruments/payNow.svg",
    logoColored: "/assets/paymentIcons/payNowColored.svg",
  },
  Emi: {
    logo: "/assets/Icons/Payment Instruments/EMI.svg",
    logoColored: "/assets/paymentIcons/EMI.svg",
  },
};

export default paymentCategoryLogoDictionary;
